import React from "react";
import { Box } from "@mui/material";

const InformationTile = ({ title, subtitle, icon: Icon = null, children }) => {
  return (
    <Box display="flex" alignItems="start" gap={1.5}>
      {Icon && <Icon />}
      <Box className="w-full">
        <div className="text-xs text-gray-500 dark:text-gray-200">{title}</div>

        {children ? <>{children}</> : !!subtitle ? subtitle : "N/A"}
      </Box>
    </Box>
  );
};

export default InformationTile;
